<section class="page">
  <header class="page-header">
    <div>
      <h1>Media library</h1>
      <p>All uploaded images — name, full S3 URL, and description</p>
    </div>
    <button class="btn btn-primary" type="button" (click)="openUpload()" [disabled]="saving()">
      Upload image
    </button>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }
  @if (success()) {
    <div class="alert alert-success">{{ success() }}</div>
  }

  @if (showUpload()) {
    <div class="panel create-panel">
      <h2>Upload to S3</h2>
      <form [formGroup]="uploadForm" (ngSubmit)="upload()" class="create-form">
        <label>
          <span>Name</span>
          <input type="text" formControlName="name" placeholder="SHEIN logo" />
        </label>
        <label>
          <span>Description</span>
          <input type="text" formControlName="description" placeholder="Optional notes" />
        </label>
        <label class="full">
          <span>Image file</span>
          <input type="file" accept="image/*" (change)="onFilePicked($event)" />
        </label>
        @if (selectedFile) {
          <p class="muted full">Selected: {{ selectedFile.name }}</p>
        }
        <div class="actions full">
          <button class="btn btn-primary" type="submit" [disabled]="saving()">
            {{ saving() ? 'Uploading…' : 'Upload' }}
          </button>
          <button class="btn btn-secondary" type="button" (click)="cancelUpload()" [disabled]="saving()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  }

  <div class="filters">
    <input
      type="search"
      [(ngModel)]="search"
      placeholder="Search name, description, URL…"
      (keyup.enter)="searchNow()"
    />
    <button class="btn btn-secondary" type="button" (click)="searchNow()" [disabled]="loading()">
      Search
    </button>
  </div>

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Description</th>
            <th>Full URL</th>
            <th>Uploaded</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="6" class="muted">Loading…</td></tr>
          } @else if (!rows().length) {
            <tr><td colspan="6" class="muted">No images yet — upload one above</td></tr>
          } @else {
            @for (row of rows(); track row.id) {
              <tr>
                <td>
                  <img class="thumb" [src]="row.url" [alt]="row.name" />
                </td>
                <td>
                  @if (editingId() === row.id) {
                    <form [formGroup]="editForm" class="inline-edit">
                      <input type="text" formControlName="name" />
                    </form>
                  } @else {
                    <strong>{{ row.name }}</strong>
                    <div class="muted mono">{{ row.original_filename || '' }}</div>
                  }
                </td>
                <td>
                  @if (editingId() === row.id) {
                    <input type="text" [formControl]="editForm.controls.description" />
                  } @else {
                    {{ row.description || '—' }}
                  }
                </td>
                <td class="url-cell">
                  <a [href]="row.url" target="_blank" rel="noopener">{{ row.url }}</a>
                </td>
                <td class="muted">{{ row.created_at | date: 'mediumDate' }}</td>
                <td class="row-actions">
                  @if (editingId() === row.id) {
                    <button class="btn btn-primary btn-sm" type="button" (click)="saveEdit()" [disabled]="saving()">
                      Save
                    </button>
                    <button class="btn btn-secondary btn-sm" type="button" (click)="cancelEdit()">Cancel</button>
                  } @else {
                    <button class="btn btn-secondary btn-sm" type="button" (click)="copyUrl(row.url)">Copy URL</button>
                    <button class="btn btn-secondary btn-sm" type="button" (click)="openEdit(row)">Edit</button>
                    <button class="btn btn-ghost btn-sm" type="button" (click)="remove(row)" [disabled]="saving()">
                      Delete
                    </button>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
    @if (total() > limit) {
      <div class="pager">
        <span class="muted">Page {{ page() }} / {{ totalPages() }} ({{ total() }} total)</span>
        <div class="pager-actions">
          <button class="btn btn-secondary btn-sm" type="button" [disabled]="page() <= 1 || loading()" (click)="load(page() - 1)">
            Prev
          </button>
          <button class="btn btn-secondary btn-sm" type="button" [disabled]="page() >= totalPages() || loading()" (click)="load(page() + 1)">
            Next
          </button>
        </div>
      </div>
    }
  </div>
</section>
